import api from "../../Http/global-vars";
import { FETCH_INVESTISSEURS } from "../types";
import axios from "axios";

export const fetchInvestisseurs = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "invest/";
    await axios
      .get(url, config)
      .then(async (res) => {
        dispatch({
          type: FETCH_INVESTISSEURS,
          payload: res
          // payload: res?.data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
